// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  CUSTOM_ELEMENTS_SCHEMA,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {
  DateFilterFn,
  DateRange,
  MatDatepickerModule,
} from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { LocalDateFormat } from 'src/app/_interfaces/data/local-data-format-model';

@Component({
  selector: 'app-cooling-date-picker',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
  ],
  templateUrl: './cooling-date-picker.component.html',
  styleUrl: './cooling-date-picker.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CoolingDatePickerComponent {
  @Input() dateFormat: LocalDateFormat | undefined;
  @Input() startDate: string = '';
  @Input() endDate: string = '';
  @Input() dateFilter: DateFilterFn<Date> | null = null;
  @Input() pickerId: string = 'datePicker';
  @Output() dateChange = new EventEmitter<DateRange<Date> | null>();

  @ViewChild('dateRangeInput') dateRangeInput: any;

  onDateChange(dateRange: DateRange<Date> | null): void {
    this.dateChange.emit(dateRange);
  }
}
